<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-供应商-添加供应商
  -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--基础设置-->
      <Basic :form="form" :gradeList="gradeList" :category="category" :app_id="app_id" :is_edit="is_edit"></Basic>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import SupplyApi from '@/api/supply.js';
import Basic from './part/Basic.vue';
export default {
  components: {
    /*基础设置*/
    Basic,
  },
  data() {
    return {
      /*表单对象*/
      form: {
        image_id: 0,
        kmd_grade_id:0,
        /*名称*/
        name: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        // 是否自营
        self_manage: 0,
        user_id:'',
        user_name:'',
        password:'',
        introduce:'',
        remark:'',
        /* 详细地址 */
        address:'',
        /* 坐标 */
        coordinate:'',
        notice:"",
       
        /*默认排序*/
        sort: 100,
        is_forbidden_buy:0,
        product_show:'two_column',
        image_url:"",
        audit_status:0,
        reject_reason:""
      },
       gradeList: [],
       app_id:0,
       is_edit:false,
      /*是否正在加载*/
      loading: false,
      category:[]
    };
  },
  created() {
    this.getGradeList();
  },
  methods: {
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form;
          delete params.tableData;
          self.loading = true;
          console.log(params);
          SupplyApi.addSupply(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    
      /*获取角色列表*/
      getGradeList() {
        // console.log(444);return 
         SupplyApi.gradeLists('', true)
          .then(res => {
            console.log(res.data.list)
            this.gradeList = res.data.list.data;
            this.app_id = res.data.app_id;
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/add.vue